/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCustomerPortfoliosInfoRequest} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'
import {GetCustomerPortfoliosInfoResponse} from '@cash-web/protos/squareup/cash/portfolios/server/service.pb'


export const getCustomerPortfoliosInfo = (request:GetCustomerPortfoliosInfoRequest, options?: CashRequestOptions) => post<GetCustomerPortfoliosInfoRequest, GetCustomerPortfoliosInfoResponse>("/2.0/cash/get-customer-portfolios-info", request, {...options, rejectOnError: true })